import request from '@/utils/request';

//新增有购买会员接口
export function getGlobalReport(param) {
  return request('/global-report/queryRegionYtdReport', {
    method: 'GET',
    params: param,
  });
}

//查询周变化趋势
export function getQueryWeeklyYtdReport(values) {
  return request('/global-report/queryWeeklyYtdReport', {
    method: 'POST',
    data: values,
  });
}

//查询数据截止时间
export function getQueryReportDeadline(values) {
  return request('/global-report/queryReportDeadline', {
    method: 'POST',
    data: values,
  });
}

//查询数据截止时间
export function getQueryWeeklyReportByStore(values) {
  return request('/global-report/queryWeeklyReportByStore', {
    method: 'POST',
    data: values,
  });
}
